import React, { useState } from 'react';
import QuizManagePanel from "./QuizManagePanel.jsx";
import { Box } from '@mui/material';
import { QUIZ_TYPE_DIS_DAT, QUIZ_TYPE_MULTIPLE_CHOICE } from './Const.js';
import MCQuestionEditor from './mc/MCQuestionEditor.jsx';
import DisDatQuestionEditor from './disdat/DisDatQuestionEditor.jsx';


export default function QuizAdmin() {

    const [quizType, setQuizType] = useState(null);
    const [questionData, setQuestionData] = useState([]);
    const [entity, setEntity] = useState([]);
    const [quizSubject, setQuizSubject] = useState([]);
    const [aiQuestionsSubjectText, setAiQuestionsSubjectText] = useState([]);

    const handleNewQuiz = (type, entity, quizSubject, aiQuestionsSubjectText) => {

        setQuestionData([]);
        setQuizType(type);

        if (entity) setEntity(entity);
        if (quizSubject) setQuizSubject(quizSubject);
        if (aiQuestionsSubjectText) setAiQuestionsSubjectText(aiQuestionsSubjectText);

    }

    const handleLoadQuiz = (quiz) => {

        setQuestionData(quiz.questionList);
        setQuizType(quiz.type);

    }

    const handleDeleteQuestion = (q) => {

        let questionDataClone = JSON.parse(JSON.stringify(questionData));
        let index = questionDataClone.findIndex((i) => i.question.templateId === q.question.templateId);

        questionDataClone.splice(index, 1);
        setQuestionData(questionDataClone);
    }

    const handleAddQuestion = (q) => {

        let questionDataClone = JSON.parse(JSON.stringify(questionData));

        questionDataClone.push(q);
        setQuestionData(questionDataClone);
    }


    const handleChangeQuestion = (updatedQuestion) => {

        setQuestionData(prevData => {
            const index = prevData.findIndex(q => q.question.templateId === updatedQuestion.question.templateId);

            const updatedData = [...prevData];

            if (index === -1) {
                updatedData.push(updatedQuestion);
            } else {
                updatedData[index] = updatedQuestion;
            }

            return updatedData;
        });
    };

    const handleUpDownQuestion = (dir, q) => {

        let questionDataClone = JSON.parse(JSON.stringify(questionData));
        let index = questionDataClone.findIndex((i) => i.question.templateId === q.question.templateId);

        if (index + dir >= 0 && index + dir < questionDataClone.length) {

            questionDataClone[index] = questionDataClone[index + dir];
            questionDataClone[index + dir] = q;
            setQuestionData(questionDataClone);
        }
    }

    const handleCreateNewQuestion = (clonedQuestionData) => {

        setQuestionData(clonedQuestionData);
    }



    return (


        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Box sx={{
                display: 'flex', maxWidth: '1400px'
            }}>

                <Box sx={{ pl: '20px', pt: '20px', mr: '15px', minWidth: '600px', height: '94vh' }}>
                    <QuizManagePanel questionData={questionData} onNewQuiz={handleNewQuiz} onLoad={handleLoadQuiz}></QuizManagePanel>
                </Box>

                <Box sx={{ pl: '20px', pt: '20px', mr: '15px', minWidth: '800px', height: '94vh' }}>


                    {quizType === QUIZ_TYPE_MULTIPLE_CHOICE && <MCQuestionEditor entity={entity} quizSubject={quizSubject} aiQuestionsSubjectText={aiQuestionsSubjectText} questionData={questionData} onCreateNewQuestion={handleCreateNewQuestion} onAddQuestion={handleAddQuestion} onDeleteQuestion={handleDeleteQuestion} onChangeQuestion={handleChangeQuestion} onUpDownQuestion={handleUpDownQuestion}></MCQuestionEditor>}

                    {quizType === QUIZ_TYPE_DIS_DAT && <DisDatQuestionEditor questionData={questionData} onChangeQuestion={handleChangeQuestion}></DisDatQuestionEditor>}


                </Box>

            </ Box >

        </Box>


    )

};
